import { Row, Col, Card, Badge, CardBody, CardTitle } from "reactstrap";
import NumberWithCommas from "../../../pages/Pages/Starter/NumberWithCommas";

import restro from "../../../assets/orderingSystem/restrologo.png";
import playBeep from "./PlayBeep";
// ============= MENU ITEM CARD COMPONENT =============
const MenuItemCard = ({ item, cartItem, onAdd, onRemove, onCardClick }) => (
  <Col xs={6} sm={6} md={3} lg={3}>
    <Card
      // className="border-0"
      className={`d-flex flex-column justify-content-between p-3 ${
        item.isProductSoldOut ? "pe-none" : "cursor-pointer"
      }`}
      style={{
        borderRadius: "10px",
        overflow: "hidden",
        boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
        cursor: "pointer",
        padding: "6px",
      }}
      onClick={() => onCardClick && onCardClick(item)}
    >
      {/* Image Section */}
      <div
        style={{
          height: "90px",
          backgroundColor: "#fafafa",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: "6px",
          overflow: "hidden",
        }}
      >
        <img
          src={item.displayImage?.getCDNUrl() || restro}
          alt={item.name}
          className={`img-fluid rounded object-fit-contain rounded-4 ${
            item.isProductSoldOut ? "opacity-50 grayscale" : ""
          }`}
          style={{
            maxWidth: "100%",
            maxHeight: "100%",
            objectFit: "contain",
            padding: "5px",
          }}
          onError={(e) => (e.target.src = restro)}
        />
        {item.isProductSoldOut && (
          <Badge
            color="danger"
            className="position-absolute top-50 start-50 translate-middle fs-12 px-3 py-2 shadow-lg"
            style={{
              zIndex: 1,
              letterSpacing: "1px",
              textTransform: "uppercase",
              fontWeight: "bold",
            }}
          >
            Sold Out
          </Badge>
        )}
        {item.discount && (
          <Badge
            color="success"
            className="position-absolute"
            style={{
              top: "5px",
              right: "5px",
              fontSize: "8px",
              padding: "2px 5px",
            }}
          >
            {item.discount}
          </Badge>
        )}
      </div>

      {/* Card Body */}
      <CardBody
        style={{
          padding: "8px",
          display: "flex",
          flexDirection: "column",
          gap: "6px",
        }}
      >
        {/* Product Name */}
        <CardTitle
          tag="h6"
          className={`text-center mb-0  ${
            item.isProductSoldOut ? "text-muted" : ""
          }`}
          style={{
            fontSize: "14px",
            fontWeight: "600",
            color: "#2c3e50",
            lineHeight: "1.2",
            height: "28px",
            overflow: "hidden",
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
          }}
        >
          {item.name}
        </CardTitle>

        {/* Price + Eye Button */}
        <div className="d-flex align-items-center justify-content-between">
          <div>
            <span
              className="fw-bold"
              style={{ fontSize: "14px", color: "#dc3545" }}
            >
              Rs. <NumberWithCommas number={item.price} />
            </span>
            {item.originalPrice && item.originalPrice > item.price && (
              <del className="ms-1" style={{ fontSize: "12px", color: "#aaa" }}>
                Rs. <NumberWithCommas number={item.originalPrice} />
              </del>
            )}
          </div>
          <button
            className="btn btn-soft-success btn-sm me-2"
            onClick={(e) => {
              playBeep();
              e.stopPropagation();
              onAdd(item);
            }}
          >
            <i className="ri-eye-2-line"></i>
          </button>
        </div>
      </CardBody>
    </Card>
  </Col>
);
// ============= MENU GRID COMPONENT =============
const MenuGrid = ({
  filteredItems,
  cart,
  onAdd,
  onRemove,
  onCardClick,
  multipleTenant,
}) => {
  if (filteredItems.length === 0) {
    return (
      <div className="text-center py-5">
        <i
          className="bx bx-food-menu"
          style={{ fontSize: "48px", color: "#ccc" }}
        />
        <p className="text-muted mt-2" style={{ fontSize: "13px" }}>
          No items available
        </p>
      </div>
    );
  }

  return (
    <div
      style={{
        height: multipleTenant ? "calc(100vh - 46.5vh)" : "calc(100vh - 40vh)",
        overflowY: "auto",
        paddingRight: "8px",
        overflowX: "hidden",
      }}
    >
      <Row className=" align-content-start">
        {filteredItems.map((item) => {
          const cartItem = cart.find((i) => i.id === item.id);
          return (
            <MenuItemCard
              key={item.id}
              item={item}
              cartItem={cartItem}
              onAdd={onAdd}
              onRemove={onRemove}
              onCardClick={onCardClick}
            />
          );
        })}
      </Row>
    </div>
  );
};

export default MenuGrid;
export { MenuItemCard };
